<template>
  <div>
        <div style="display: flex; flex-direction: row; justify-content: space-between; position: relative; top: 0px; width: 100%; flex-wrap: wrap;">
          
            <router-link style="top: 0px; position: relative; width: 250px; left: 20px;" :to="'/'+(getRefIndex !== null ? ''+getRefIndex.url : '')">
                <img src="https://raizzoncdn.b-cdn.net/coastalkia5k/main-logo.png" alt="" style="width: 200px;">
            </router-link>
            <a v-if="getRefIndex !== null" style="top: 0px; position: relative; background-color: rgba(255, 255, 255, 0.7); padding: 10px;" 
                :href="getRefIndex.master_url"><img :src="getRefIndex.logo" alt="" style="max-width: 100px;"></a>
      
            <div style="text-align: right; margin: 20px;">

                <router-link :to="'/about'+(getRefIndex !== null ? '/'+getRefIndex.url : '')" 
                    style="padding: 10px; border-radius: 10px;
                    background-color: #383838;
                    font-size: 16px; font-family: 'Roboto', sans-serif; font-weight: bold; 
                    color: white; text-transform: uppercase; max-height: 25px;">About Us</router-link>
                    
                <a :href="'/contact'+(getRefIndex !== null ? '/'+getRefIndex.url : '')" 
                    style="padding: 10px; border-radius: 10px;
                    background-color: #383838;
                    font-size: 16px; font-family: 'Roboto', sans-serif; font-weight: bold; 
                    color: white; text-transform: uppercase; max-height: 25px;">Contact</a>

            </div>
            
        </div>
  </div>
</template>

<script>
export default {
    computed: {
        getRefIndex() {
            return this.$store.getters.getRefCompany
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Navs.vue